/**
 * @file bit to work with cookies
 */

const getCookie = (name: string): string => {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v != null ? v[2] : ''
}

interface SetCookieOptions {
  maxAgeInSeconds?: number
  expires?: string
  path?: string
  domain?: string
}

function buildCookieString(name: string, value: string, options: SetCookieOptions = {}): string {
  const maxAgeString = options.maxAgeInSeconds ? `;max-age=${options.maxAgeInSeconds}` : ''
  const expiresString = options.expires ? `;expires=${options.expires}` : ''
  const pathString = options.path ? `;path=${options.path}` : ';path=/'
  const domainString = options.domain ? `;domain=${options.domain}` : ''
  return `${name}=${value}${maxAgeString}${expiresString}${pathString}${domainString}`
}

function setCookie(name: string, value: string, options: SetCookieOptions = {}): void {
  document.cookie = buildCookieString(name, value, options)
}

function deleteCookie(name: string): void {
  setCookie(name, '', {
    maxAgeInSeconds: 0,
    expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
    path: '/',
  })
}

function getExperimentVariantCookie(experimentName: string): string {
  const wwX = getCookie('ww_x')
  if (wwX == null) {
    return ''
  }
  const parsed = JSON.parse(decodeURIComponent(wwX))
  return parsed[experimentName] ?? ''
}

export { buildCookieString, deleteCookie, getCookie, getExperimentVariantCookie, setCookie }
